import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Library, Target, CalendarCheck, LayoutDashboard, ListTodo, LogOut, PenLine, Rss } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const { address, disconnect } = useAuth();
  const dailyView = new URLSearchParams(location.search).get('view');
  const isFocus = location.pathname.replace(/\/$/, '') === '/daily' && !['today', 'history'].includes(dailyView);
  const currentDate = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const navItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/feeds', icon: Rss, label: 'Feeds' },
    { path: '/daily', icon: ListTodo, label: 'Daily' },
    { path: '/goals', icon: Target, label: 'Goals' },
    { path: '/writing', icon: PenLine, label: 'Writing' },
    { path: '/materials', icon: Library, label: 'Materials' },
    { path: '/checkin', icon: CalendarCheck, label: 'Check-in' },
  ];

  return (
    <div className={`layout ${isFocus ? 'layout-focus' : ''}`}>
      {!isFocus && <aside className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-text">Samuel's</span>
            <span className="logo-year">2026</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(({ path, icon: Icon, label }) => (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={20} strokeWidth={1.5} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="current-date">{currentDate}</div>
          {address && (
            <div className="wallet-info">
              <span className="wallet-address">
                {address.slice(0, 6)}...{address.slice(-4)}
              </span>
              <button className="disconnect-btn" onClick={disconnect} title="Disconnect wallet">
                <LogOut size={16} />
              </button>
            </div>
          )}
        </div>
      </aside>}

      <main className="main-content">
        <div className="content-wrapper">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
